<template>
  <CommonBanner type="positive" :tagline="bannerText" :title="amount" />
  <template v-if="isFullyPaid && isFromAlert">
    <CommonBanner
      type="neutral"
      :additional="$t`Теперь вы можете уменьшить лимит на покупки`"
    />
    <CommonButton
      class="btn btn__primary"
      spaced
      @click="
        $router.replace({
          path: '/bank/red/reduce-limit',
          query: { src: 'prepayment' },
        })
      "
    >
      {{ $t`Уменьшить лимит` }}
    </CommonButton>
  </template>
  <ProductButton
    @click="$router.replace('/bank/red/paymentcalendar?src=prepayment')"
  >
    <template v-if ="isAbTest" #title>
      <div 
       v-html='
          $t`Вы можете отслеживать задолженность в <a class=\"link-to-gid__anchor\">Календаре счетов<\/a>`
        '>
      </div>
    </template>
    <template v-else #title>
      <span class="text-primary">{{ $t`Календарь счетов` }}</span>
    </template>
    <template v-if ="!isAbTest" #tail>
      <div class="i-arrow"></div>
    </template>
  </ProductButton>
  <CommonButton
    class="btn btn__secondary"
    spaced
    :flat="isFullyPaid && isFromAlert"
    @click="$router.replace('/bank/red')"
  >
    {{ $t`Вернуться в Kaspi Red` }}
  </CommonButton>
</template>

<script>
import CommonBanner from "@/components/shared/banner/CommonBanner.vue";
import CommonButton from "@/components/shared/button/CommonButton.vue";
import ProductButton from "@/components/shared/button/ProductButton.vue";

export default {
  components: {
    ProductButton,
    CommonButton,
    CommonBanner,
  },
  data() {
    return {
      payments: null,
    };
  },
  mounted() {
    this.$logAnalyticEvent("mybank_red_prepayment_complete", {
      type: this.isFullyPaid ? "fully" : "partly",
      amount: this.amount,
      page_path: "",
      started_from: "",
    });
  },
  computed: {
    isFromAlert() {
      return this.$route.query.fromAlert === "true";
    },
    isFullyPaid() {
      return this.$route.query.type === "full";
    },
    amount() {
      return this.$currencyFormatter(this.$route.query.amount);
    },
    isAbTest(){
      return this.$route.query.isAbTest === "true";
    },
    bannerText() {
      return this.isFullyPaid
        ? this.isAbTest ? this.$t`Задолженность полностью погашена` : this.$t`Ваша задолженность полностью погашена`
        : this.isAbTest ? this.$t`Задолженность частично погашена` : this.$t`Ваша задолженность частично погашена`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.text-primary {
  color: $colorCerulean;
}

.payments {
  padding: 8px 0 10px;
  font-family: Roboto-Regular;

  &__title {
    padding: 8px 16px;
    font-size: 12px;
    line-height: 14px;
    text-align: left;
    text-transform: uppercase;
    color: #a8a8a8;
  }
}
</style>
